// extracted by mini-css-extract-plugin
export default {"example-switch":"OnePageExampleSwitch_example-switch__hy-HY","example-switch--mobile":"OnePageExampleSwitch_example-switch--mobile__baN+R"};